export interface BnmRate {
  CharCode: string;
  Value: string | number;
  Name?: string;
  Nominal?: string | number;
}

export interface NormalizedBnmRates {
  Date?: string;
  Valute: BnmRate[];
  stale: boolean;
}

export const normalizeBnmRates = (input: unknown): NormalizedBnmRates => {
  let payload: any = input;
  // Older endpoints and stored JSON values may have an extra JSON layer.
  for (let depth = 0; depth < 2 && typeof payload === 'string'; depth += 1) {
    try { payload = JSON.parse(payload); } catch { payload = null; }
  }
  const source = payload?.Valute ? payload : payload?.ValCurs;
  const raw = source?.Valute;
  const rows: any[] = Array.isArray(raw) ? raw : raw && typeof raw === 'object' ? [raw] : [];
  const seen = new Set<string>();
  const Valute: BnmRate[] = [];
  rows.forEach((row) => {
    const code = String(row?.CharCode ?? '').trim().toUpperCase();
    const rawValue = String(row?.Value ?? '').trim().replace(',', '.');
    const value = Number(rawValue);
    const nominal = Number(String(row?.Nominal ?? 1).replace(',', '.'));
    if (!/^[A-Z]{3}$/.test(code) || seen.has(code) || !Number.isFinite(value) || value <= 0 || !Number.isFinite(nominal) || nominal <= 0) return;
    seen.add(code);
    Valute.push({
      CharCode: code,
      Name: typeof row.Name === 'string' ? row.Name : undefined,
      Value: nominal === 1 ? rawValue : String(value / nominal),
      Nominal: '1',
    });
  });
  const date = source?.Date ?? source?.['@Date'];
  return { Date: typeof date === 'string' ? date : undefined, Valute, stale: payload?.stale === true };
};

export const formatBnmDate = (value?: string): string | undefined => {
  if (!value) return undefined;
  const dotted = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(value);
  if (dotted) return `${dotted[1]}/${dotted[2]}/${dotted[3]}`;
  const iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  return iso ? `${iso[3]}/${iso[2]}/${iso[1]}` : undefined;
};

export const dashboardBnmRates = (rates: BnmRate[] = []): BnmRate[] =>
  ['EUR', 'USD', 'RUB', 'RON', 'UAH']
    .map((code) => rates.find((rate) => rate.CharCode === code))
    .filter((rate): rate is BnmRate => Boolean(rate));
